function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-124"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "233.12 285.5 231.91 285.5 231.91 284.7 232.31 284.7 232.31 284.3 233.12 284.3 233.12 285.5",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.31,285.5h-1.6v-.8h1.6Zm-3.2,0h-1.6v-.8h1.6Zm-3.21,0h-1.6v-.8h1.6Zm-3.2,0h-1.6v-.8h1.6Zm-3.2,0h-1.61v-.8h1.61Zm-3.21,0h-1.6v-.8h1.6Zm-3.2,0h-1.6v-.8h1.6Zm-3.21,0h-1.6v-.8h1.6Zm-3.2,0h-1.6v-.8h1.6Zm-3.2,0h-1.61v-.8h1.61Zm-3.21,0h-1.6v-.8h1.6Zm-3.2,0h-1.6v-.8h1.6Zm-3.21,0h-1.6v-.8h1.6Zm-3.2,0h-1.6v-.8h1.6Zm-3.2,0h-1.61v-.8h1.61Zm-3.21,0h-1.6v-.8h1.6Zm-3.2,0h-1.6v-.8h1.6Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.84 285.5 174.64 285.5 174.64 284.3 175.44 284.3 175.44 284.7 175.84 284.7 175.84 285.5",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.44,282.7h-.8v-1.6h.8Zm0-3.21h-.8v-1.6h.8Zm0-3.2h-.8v-1.6h.8Zm0-3.2h-.8v-1.61h.8Zm0-3.21h-.8v-1.6h.8Zm0-3.2h-.8v-1.6h.8Zm0-3.21h-.8v-1.6h.8Zm0-3.2h-.8v-1.6h.8Zm0-3.2h-.8v-1.61h.8Zm0-3.21h-.8v-1.6h.8Zm0-3.2h-.8v-1.6h.8Zm0-3.21h-.8v-1.6h.8Zm0-3.2h-.8v-1.6h.8Zm0-3.2h-.8v-1.61h.8Zm0-3.21h-.8v-1.6h.8Zm0-3.2h-.8V233h.8Zm0-3.21h-.8v-1.6h.8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.44 228.23 174.64 228.23 174.64 227.03 175.84 227.03 175.84 227.83 175.44 227.83 175.44 228.23",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.31,227.83h-1.6V227h1.6Zm-3.2,0h-1.6V227h1.6Zm-3.21,0h-1.6V227h1.6Zm-3.2,0h-1.6V227h1.6Zm-3.2,0h-1.61V227h1.61Zm-3.21,0h-1.6V227h1.6Zm-3.2,0h-1.6V227h1.6Zm-3.21,0h-1.6V227h1.6Zm-3.2,0h-1.6V227h1.6Zm-3.2,0h-1.61V227h1.61Zm-3.21,0h-1.6V227h1.6Zm-3.2,0h-1.6V227h1.6Zm-3.21,0h-1.6V227h1.6Zm-3.2,0h-1.6V227h1.6Zm-3.2,0h-1.61V227h1.61Zm-3.21,0h-1.6V227h1.6Zm-3.2,0h-1.6V227h1.6Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.12 228.23 232.31 228.23 232.31 227.83 231.91 227.83 231.91 227.03 233.12 227.03 233.12 228.23",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.12,282.7h-.81v-1.6h.81Zm0-3.21h-.81v-1.6h.81Zm0-3.2h-.81v-1.6h.81Zm0-3.2h-.81v-1.61h.81Zm0-3.21h-.81v-1.6h.81Zm0-3.2h-.81v-1.6h.81Zm0-3.21h-.81v-1.6h.81Zm0-3.2h-.81v-1.6h.81Zm0-3.2h-.81v-1.61h.81Zm0-3.21h-.81v-1.6h.81Zm0-3.2h-.81v-1.6h.81Zm0-3.21h-.81v-1.6h.81Zm0-3.2h-.81v-1.6h.81Zm0-3.2h-.81v-1.61h.81Zm0-3.21h-.81v-1.6h.81Zm0-3.2h-.81V233h.81Zm0-3.2h-.81v-1.61h.81Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.45,
    y: 281.51,
    width: 7.19,
    height: 7.19,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179,289.09h-8v-8h8Zm-7.19-.8h6.39v-6.38h-6.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.48,
    y: 252.67,
    width: 7.19,
    height: 7.19,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179,260.26h-8v-8h8Zm-7.19-.8h6.39v-6.39h-6.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.48,
    y: 223.84,
    width: 7.19,
    height: 7.19,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179,231.42h-8v-8h8Zm-7.19-.8h6.39v-6.38h-6.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.15,
    y: 281.51,
    width: 7.19,
    height: 7.19,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.71,289.09h-8v-8h8Zm-7.19-.8h6.39v-6.38h-6.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.15,
    y: 252.67,
    width: 7.19,
    height: 7.19,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.71,260.26h-8v-8h8Zm-7.19-.8h6.39v-6.39h-6.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.15,
    y: 223.84,
    width: 7.19,
    height: 7.19,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.71,231.42h-8v-8h8Zm-7.19-.8h6.39v-6.38h-6.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.32,
    y: 223.84,
    width: 7.19,
    height: 7.19,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.87,231.42h-8v-8h8Zm-7.18-.8h6.38v-6.38h-6.38Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.29,
    y: 281.51,
    width: 7.19,
    height: 7.19,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.87,289.09h-8v-8h8Zm-7.18-.8h6.38v-6.38h-6.38Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "578.55 162.84 577.35 162.84 577.35 162.03 577.75 162.03 577.75 161.63 578.55 161.63 578.55 162.84",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.75,162.84h-1.61V162h1.61Zm-3.21,0h-1.6V162h1.6Zm-3.2,0h-1.6V162h1.6Zm-3.21,0h-1.6V162h1.6Zm-3.2,0h-1.6V162h1.6Zm-3.2,0h-1.61V162h1.61Zm-3.21,0h-1.6V162h1.6Zm-3.2,0h-1.6V162h1.6Zm-3.21,0h-1.6V162h1.6Zm-3.2,0h-1.6V162h1.6Zm-3.2,0H542.1V162h1.61Zm-3.21,0h-1.6V162h1.6Zm-3.2,0h-1.6V162h1.6Zm-3.21,0h-1.6V162h1.6Zm-3.2,0h-1.6V162h1.6Zm-3.2,0h-1.61V162h1.61Zm-3.21,0h-1.6V162h1.6Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "521.28 162.84 520.08 162.84 520.08 161.63 520.88 161.63 520.88 162.03 521.28 162.03 521.28 162.84",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.88,160h-.8v-1.6h.8Zm0-3.2h-.8v-1.6h.8Zm0-3.21h-.8V152h.8Zm0-3.2h-.8v-1.6h.8Zm0-3.2h-.8v-1.61h.8Zm0-3.21h-.8v-1.6h.8Zm0-3.2h-.8v-1.6h.8Zm0-3.21h-.8V136h.8Zm0-3.2h-.8v-1.6h.8Zm0-3.2h-.8v-1.61h.8Zm0-3.21h-.8v-1.6h.8Zm0-3.2h-.8v-1.6h.8Zm0-3.2h-.8V120h.8Zm0-3.21h-.8v-1.6h.8Zm0-3.2h-.8v-1.6h.8Zm0-3.21h-.8v-1.6h.8Zm0-3.2h-.8v-1.6h.8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "520.88 105.57 520.08 105.57 520.08 104.36 521.28 104.36 521.28 105.17 520.88 105.17 520.88 105.57",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.75,105.16h-1.61v-.8h1.61Zm-3.21,0h-1.6v-.8h1.6Zm-3.2,0h-1.6v-.8h1.6Zm-3.21,0h-1.6v-.8h1.6Zm-3.2,0h-1.6v-.8h1.6Zm-3.2,0h-1.61v-.8h1.61Zm-3.21,0h-1.6v-.8h1.6Zm-3.2,0h-1.6v-.8h1.6Zm-3.21,0h-1.6v-.8h1.6Zm-3.2,0h-1.6v-.8h1.6Zm-3.2,0H542.1v-.8h1.61Zm-3.21,0h-1.6v-.8h1.6Zm-3.2,0h-1.6v-.8h1.6Zm-3.21,0h-1.6v-.8h1.6Zm-3.2,0h-1.6v-.8h1.6Zm-3.2,0h-1.61v-.8h1.61Zm-3.21,0h-1.6v-.8h1.6Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "578.55 105.57 577.75 105.57 577.75 105.17 577.35 105.17 577.35 104.36 578.55 104.36 578.55 105.57",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.55,160h-.8v-1.6h.8Zm0-3.2h-.8v-1.6h.8Zm0-3.21h-.8V152h.8Zm0-3.2h-.8v-1.6h.8Zm0-3.2h-.8v-1.61h.8Zm0-3.21h-.8v-1.6h.8Zm0-3.2h-.8v-1.6h.8Zm0-3.21h-.8V136h.8Zm0-3.2h-.8v-1.6h.8Zm0-3.2h-.8v-1.61h.8Zm0-3.21h-.8v-1.6h.8Zm0-3.2h-.8v-1.6h.8Zm0-3.2h-.8V120h.8Zm0-3.21h-.8v-1.6h.8Zm0-3.2h-.8v-1.6h.8Zm0-3.21h-.8v-1.6h.8Zm0-3.2h-.8v-1.6h.8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.88,
    y: 158.84,
    width: 7.19,
    height: 7.19,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.47,166.43h-8v-8h8Zm-7.19-.8h6.39v-6.39h-6.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.91,
    y: 130.01,
    width: 7.19,
    height: 7.19,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.47,137.59h-8v-8h8Zm-7.19-.8h6.39v-6.38h-6.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.91,
    y: 101.17,
    width: 7.19,
    height: 7.19,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.47,108.76h-8v-8h8Zm-7.19-.8h6.39v-6.39h-6.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 574.59,
    y: 158.84,
    width: 7.19,
    height: 7.19,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.14,166.43h-8v-8h8Zm-7.18-.8h6.38v-6.39H575Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 574.59,
    y: 130.01,
    width: 7.19,
    height: 7.19,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.14,137.59h-8v-8h8Zm-7.18-.8h6.38v-6.38H575Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 574.59,
    y: 101.17,
    width: 7.19,
    height: 7.19,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.14,108.76h-8v-8h8ZM575,108h6.38v-6.39H575Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 545.75,
    y: 101.17,
    width: 7.19,
    height: 7.19,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.31,108.76h-8v-8h8Zm-7.19-.8h6.39v-6.39h-6.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 545.72,
    y: 158.84,
    width: 7.19,
    height: 7.19,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.31,166.43h-8v-8h8Zm-7.19-.8h6.39v-6.39h-6.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212,144.09H85.36V57.45H212Zm-125.64-1H211V58.45H86.36Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.26,63a2.52,2.52,0,1,1-2.52-2.52A2.52,2.52,0,0,1,95.26,63Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.55,63A2.52,2.52,0,1,1,103,60.51,2.52,2.52,0,0,1,105.55,63Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.85,63a2.53,2.53,0,1,1-2.52-2.52A2.52,2.52,0,0,1,115.85,63Z",
    style: {
      fill: "#105099"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.86,
    y: 67.47,
    width: 125.64,
    height: 1,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.88,205.68a2.14,2.14,0,0,1,2.26,0l.57.32.6.31a2.13,2.13,0,0,1,1.25,1.86l.09,2.76,9-.28-.09-2.76a2.16,2.16,0,0,1,1.13-1.95,12.15,12.15,0,0,0,1.15-.7,2.13,2.13,0,0,1,2.24-.15l2.43,1.31,4.27-8-2.44-1.3a2.17,2.17,0,0,1-1.12-1.95,12.07,12.07,0,0,0,0-1.34,2.14,2.14,0,0,1,1-2l2.35-1.46-4.75-7.66-2.37,1.46a2.13,2.13,0,0,1-2.24,0l-.57-.32q-.3-.16-.6-.3a2.15,2.15,0,0,1-1.25-1.87l-.09-2.77-9,.28.08,2.76a2.13,2.13,0,0,1-1.13,2,11.35,11.35,0,0,0-1.14.71,2.15,2.15,0,0,1-2.24.14l-2.44-1.3-4.26,8,2.43,1.3a2.16,2.16,0,0,1,1.12,2,12.18,12.18,0,0,0,0,1.35,2.14,2.14,0,0,1-1,2l-2.35,1.45,4.75,7.67Zm2.26-14.24a7.39,7.39,0,1,1,3,10A7.39,7.39,0,0,1,182.14,191.44Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.94,171.18a1.48,1.48,0,0,1,1.39-.74h.94a1.51,1.51,0,0,1,1.39.73l1,1.68,5.48-3.15-1-1.68a1.5,1.5,0,0,1,.06-1.58,9.23,9.23,0,0,0,.47-.82,1.51,1.51,0,0,1,1.33-.83h1.94v-6.32H214a1.5,1.5,0,0,1-1.33-.83c-.15-.28-.3-.55-.47-.81a1.5,1.5,0,0,1-.06-1.58l1-1.68-5.48-3.16-1,1.69a1.49,1.49,0,0,1-1.39.73h-.93a1.49,1.49,0,0,1-1.39-.73l-1-1.69-5.48,3.16,1,1.68a1.48,1.48,0,0,1-.05,1.57c-.17.27-.33.54-.47.82a1.5,1.5,0,0,1-1.34.83h-1.93v6.32h1.93a1.51,1.51,0,0,1,1.34.84,8.13,8.13,0,0,0,.47.81,1.5,1.5,0,0,1,.05,1.58l-1,1.68,5.48,3.15Zm-3.32-9.54a5.18,5.18,0,1,1,5.18,5.17A5.18,5.18,0,0,1,199.62,161.64Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563,339.26a1.5,1.5,0,0,1-.74-1.4c0-.15,0-.3,0-.46s0-.31,0-.47a1.49,1.49,0,0,1,.73-1.39l1.68-1-3.15-5.47-1.68,1a1.52,1.52,0,0,1-1.58-.06,7.28,7.28,0,0,0-.82-.47,1.52,1.52,0,0,1-.83-1.34v-1.93H550.3v1.93a1.5,1.5,0,0,1-.83,1.34,8.13,8.13,0,0,0-.81.47,1.52,1.52,0,0,1-1.58.06l-1.68-1-3.16,5.47,1.69,1a1.49,1.49,0,0,1,.73,1.38c0,.16,0,.31,0,.47s0,.31,0,.46a1.52,1.52,0,0,1-.73,1.4l-1.69,1,3.16,5.47,1.68-1a1.5,1.5,0,0,1,1.57.06c.27.17.54.33.82.47a1.5,1.5,0,0,1,.83,1.34v1.93h6.32V346.6a1.51,1.51,0,0,1,.84-1.34,8.13,8.13,0,0,0,.81-.47,1.52,1.52,0,0,1,1.58-.06l1.68,1,3.15-5.47Zm-9.54,3.32a5.18,5.18,0,1,1,5.17-5.18A5.18,5.18,0,0,1,553.47,342.58Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.22,263.9a3.72,3.72,0,0,1,3.92,0c.33.2.67.39,1,.57s.69.36,1,.53a3.73,3.73,0,0,1,2.18,3.24l.15,4.83,15.72-.49-.15-4.86a3.72,3.72,0,0,1,2-3.36,21.8,21.8,0,0,0,2-1.21,3.78,3.78,0,0,1,3.94-.27l4.24,2.28,7.44-13.87L135.42,249a3.76,3.76,0,0,1-1.95-3.43c0-.77,0-1.53-.08-2.29a3.73,3.73,0,0,1,1.7-3.52l4.13-2.56-8.29-13.37-4.12,2.56a3.7,3.7,0,0,1-3.86,0c-.34-.21-.7-.41-1.06-.61l-1.09-.55a3.68,3.68,0,0,1-2.13-3.22l-.15-4.83-15.73.48.16,4.82a3.68,3.68,0,0,1-1.91,3.35,23.52,23.52,0,0,0-2.13,1.32,3.64,3.64,0,0,1-3.84.21l-4.25-2.27L83.39,239l4.24,2.27a3.77,3.77,0,0,1,2,3.44,21.81,21.81,0,0,0,.08,2.29A3.73,3.73,0,0,1,88,250.52l-4.12,2.55,8.29,13.37Zm3.24-23.3a12.89,12.89,0,1,1,4.54,15A12.9,12.9,0,0,1,99.46,240.6Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.72,214.29a2.61,2.61,0,0,1,2.43-1.28l.82,0,.81,0a2.64,2.64,0,0,1,2.43,1.27l1.69,2.94,9.55-5.51-1.69-2.93a2.62,2.62,0,0,1,.09-2.75,15.48,15.48,0,0,0,.83-1.42,2.6,2.6,0,0,1,2.32-1.45h3.38v-11H162a2.6,2.6,0,0,1-2.32-1.45,15.48,15.48,0,0,0-.83-1.42,2.62,2.62,0,0,1-.09-2.75l1.69-2.93-9.55-5.51L149.2,181a2.62,2.62,0,0,1-2.42,1.28l-.81,0-.82,0a2.63,2.63,0,0,1-2.43-1.28L141,178.08l-9.54,5.51,1.69,2.92a2.64,2.64,0,0,1-.1,2.75,14.33,14.33,0,0,0-.82,1.43,2.63,2.63,0,0,1-2.33,1.45h-3.38v11h3.38a2.63,2.63,0,0,1,2.33,1.45,15.55,15.55,0,0,0,.82,1.43,2.64,2.64,0,0,1,.1,2.75l-1.69,2.92,9.54,5.51Zm-5.79-16.64a9,9,0,1,1,9,9A9,9,0,0,1,136.93,197.65Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.61,182.61l-5.51-9.55-2.92,1.69a2.6,2.6,0,0,1-2.74-.09,15.64,15.64,0,0,0-1.43-.83,2.63,2.63,0,0,1-1.45-2.33v-3.37h-11v3.37a2.61,2.61,0,0,1-1.45,2.33,15.48,15.48,0,0,0-1.42.83,2.62,2.62,0,0,1-2.75.09L633,173.06l-5.51,9.55,2.94,1.69a2.62,2.62,0,0,1,1.28,2.43c0,.27,0,.54,0,.81s0,.54,0,.81a2.6,2.6,0,0,1-1.28,2.42l-2.94,1.7L633,202l2.93-1.69a2.6,2.6,0,0,1,2.75.1,14.17,14.17,0,0,0,1.42.82,2.62,2.62,0,0,1,1.44,2.33V207h11v-3.37a2.63,2.63,0,0,1,1.45-2.33,15.38,15.38,0,0,0,1.42-.82,2.6,2.6,0,0,1,2.75-.1L661.1,202l5.51-9.55-2.93-1.69a2.62,2.62,0,0,1-1.28-2.42c0-.27,0-.55,0-.82s0-.54,0-.81a2.62,2.62,0,0,1,1.29-2.43Zm-10.53,4.93a9,9,0,1,1-9-9A9,9,0,0,1,656.08,187.54Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--aiZGp2--inject-124"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M597.46,69.24a71.13,71.13,0,0,0-4.82,22.05H573.1v-.54c0-.5.11-1,.16-1.5a54.28,54.28,0,0,1,1.29-7.7,59.2,59.2,0,0,1,4.34-12,.43.43,0,0,1,.47-.29h18.1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.87,118.5H578.93a.41.41,0,0,1-.44-.28A54.68,54.68,0,0,1,574,104.66a56.59,56.59,0,0,1-.88-6.87,1,1,0,0,0,0-.24V97l.29,0H592.3c.35,0,.33,0,.35.35.12,1.57.23,3.14.38,4.71a61.49,61.49,0,0,0,1.2,7.39,67.25,67.25,0,0,0,2.55,8.78C596.81,118.3,596.84,118.39,596.87,118.5Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.35,124.19l-.15.27a54.08,54.08,0,0,1-5.09,6.59,49.49,49.49,0,0,1-7.45,6.87,53.4,53.4,0,0,1-17.47,8.75,55.77,55.77,0,0,1-7.47,1.6c-.25,0-.49.08-.74.12h-.43l-.41-.27.47-.33a57.55,57.55,0,0,0,14.16-13.73,64.86,64.86,0,0,0,5.78-9.6.41.41,0,0,1,.44-.27h18.36Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.4,91.28H629.19v-22h19.68a.37.37,0,0,1,.4.26,61.92,61.92,0,0,1,4,12.91,65.63,65.63,0,0,1,1,7C654.29,90,654.35,90.63,654.4,91.28Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.25,97.15c0,.53,0,1-.08,1.56-.11,1.23-.19,2.46-.37,3.68-.23,1.68-.49,3.37-.83,5a59.75,59.75,0,0,1-3.27,10.75.41.41,0,0,1-.46.32H629V97.15Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.5,69.38V91.44H598.88c0-.56.06-1.11.11-1.65.13-1.23.23-2.48.42-3.7.31-1.87.63-3.74,1-5.59A57.74,57.74,0,0,1,604,69.64a.38.38,0,0,1,.42-.27H623.5Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.53,97.45q0,10.36,0,20.74v.31H603.85a.39.39,0,0,1-.43-.29,56.1,56.1,0,0,1-3.35-11.12c-.37-2-.65-3.94-.9-5.91-.16-1.29-.2-2.6-.29-3.9,0,0,0-.07,0-.14h24.33C623.47,97.13,623.53,97.2,623.53,97.45Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.13,91.43H660.47a71.87,71.87,0,0,0-4.81-22.19h19.25a.42.42,0,0,1,.45.27,54.08,54.08,0,0,1,4.77,13.81,59.3,59.3,0,0,1,1,7.75C681.14,91.18,681.13,91.29,681.13,91.43Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.15,97c0,.5,0,1-.07,1.44-.14,1.87-.36,3.73-.68,5.57a53.75,53.75,0,0,1-3.8,12.4c-.28.64-.58,1.28-.87,1.91a.29.29,0,0,1-.31.2H656.24l.68-1.95A69,69,0,0,0,660.36,99c0-.59.07-1.19.1-1.78,0-.16,0-.24.21-.22a1.2,1.2,0,0,0,.19,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.79,63.61a.36.36,0,0,0,0,.09H653.42a.42.42,0,0,1-.44-.25,61.68,61.68,0,0,0-9-13.29,49.25,49.25,0,0,0-6.88-6.35c-1.23-1-2.51-1.83-3.77-2.75l-.21-.16.25-.17c0-.11-.07-.23-.12-.39a54.1,54.1,0,0,1,38.51,23.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620,148.14a2.57,2.57,0,0,1-.52.09,49,49,0,0,1-5.89-1.15,53.08,53.08,0,0,1-10.49-3.88,53.68,53.68,0,0,1-10.68-7,50.65,50.65,0,0,1-6.43-6.42,53.32,53.32,0,0,1-4-5.56l-.08-.17H599a.41.41,0,0,1,.42.28,66.24,66.24,0,0,0,6.18,10.08,64.11,64.11,0,0,0,7.25,8,56.21,56.21,0,0,0,7,5.61Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.78,40.88c-.77.56-1.67,1.2-2.55,1.87a63,63,0,0,0-8.15,7.59,57.11,57.11,0,0,0-8.55,12.2c-.15.28-.28.57-.44.84a.37.37,0,0,1-.26.16c-.31,0-.61,0-.92,0H582.46c9.17-12.94,21.47-20.72,37.13-23.09a2.12,2.12,0,0,1-.11.21Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.88,124.21a59.56,59.56,0,0,1-8.33,11.26,52.56,52.56,0,0,1-9.51,8.07V124.21Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.5,124.21v19a54.68,54.68,0,0,1-17.11-19Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.31,63.53H629.19V45.47a52.25,52.25,0,0,1,9.61,8A60.52,60.52,0,0,1,646.31,63.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.5,46V63.68H607.07A52.09,52.09,0,0,1,623.5,46Z",
    style: {
      fill: "#ebebeb"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-124"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 439.08,
    cy: 453.13,
    rx: 174.67,
    ry: 16.83,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-124"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "47.63 367.16 129.47 366.92 211.31 366.83 375 366.66 538.69 366.83 620.53 366.92 702.37 367.16 620.53 367.41 538.69 367.49 375 367.66 211.31 367.49 129.47 367.4 47.63 367.16",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-124"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 153.44,
    y: 77.94,
    width: 441.45,
    height: 295.29,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.64,
    y: 81.54,
    width: 435.03,
    height: 288.09,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.94,
    y: 395.38,
    width: 556.44,
    height: 20.27,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.94 395.38 153.44 373.24 594.88 373.24 652.38 395.38 95.94 395.38",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.57 387.53 195.67 373.24 552.64 373.24 589.75 387.53 158.57 387.53",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.23,
    y: 103.43,
    width: 385.86,
    height: 244.32,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.9,
    y: 103.43,
    width: 386.19,
    height: 9.4,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.38,108.13A2.34,2.34,0,1,1,186,105.8,2.33,2.33,0,0,1,188.38,108.13Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.9,108.13a2.34,2.34,0,1,1-2.34-2.33A2.33,2.33,0,0,1,197.9,108.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.42,108.13a2.34,2.34,0,1,1-2.33-2.33A2.33,2.33,0,0,1,207.42,108.13Z",
    style: {
      fill: "#105099"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.51,
    y: 198.37,
    width: 188.98,
    height: 25.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470,224.66H280V197.87H470Zm-189-1H469V198.87H281Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.71,
    y: 198.37,
    width: 25.79,
    height: 25.78,
    style: {
      fill: "#105099"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.77,218.49l-2.38,1.81L458,214.47l-1.61-2.13a3.67,3.67,0,0,0,.92-.52,3.83,3.83,0,0,0,1.22-1.59l1.72,2.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.09,204.78a6.5,6.5,0,1,0-2.11,9.69,7.24,7.24,0,0,0,.9-.58,6.62,6.62,0,0,0,1.35-1.4A6.5,6.5,0,0,0,460.09,204.78Zm-2.8,7a3.67,3.67,0,0,1-.92.52,3.89,3.89,0,1,1,2.14-2.11A3.83,3.83,0,0,1,457.29,211.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.9,
    y: 203.44,
    width: 1.38,
    height: 15.65,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.51,
    y: 234.21,
    width: 43.65,
    height: 13.83,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.17,
    y: 234.21,
    width: 43.65,
    height: 13.83,
    style: {
      fill: "#105099"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.38,
    y: 234.21,
    width: 43.65,
    height: 13.83,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.72,
    y: 170.45,
    width: 120.55,
    height: 8.37,
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Files--inject-124"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "249.19 262.67 183.6 262.67 183.6 178.48 232.3 178.48 249.19 194.52 249.19 262.67",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.3 178.48 249.19 194.52 232.3 194.52 232.3 178.48",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 192.61,
    width: 36.46,
    height: 2.16,
    transform: "translate(416.46 387.38) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 198.06,
    width: 36.46,
    height: 2.16,
    transform: "translate(416.46 398.29) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 203.52,
    width: 36.46,
    height: 2.16,
    transform: "translate(416.46 409.2) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 208.98,
    width: 53.43,
    height: 2.16,
    transform: "translate(433.43 420.12) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 214.43,
    width: 53.43,
    height: 2.16,
    transform: "translate(433.43 431.03) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 219.89,
    width: 53.43,
    height: 2.16,
    transform: "translate(433.43 441.94) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 225.35,
    width: 53.43,
    height: 2.16,
    transform: "translate(433.43 452.86) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 230.8,
    width: 53.43,
    height: 2.16,
    transform: "translate(433.43 463.77) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 236.26,
    width: 53.43,
    height: 2.16,
    transform: "translate(433.43 474.68) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 241.72,
    width: 53.43,
    height: 2.16,
    transform: "translate(433.43 485.6) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 247.17,
    width: 53.43,
    height: 2.16,
    transform: "translate(433.43 496.51) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 252.63,
    width: 53.43,
    height: 2.16,
    transform: "translate(433.43 507.42) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.49,
    y: 204.97,
    width: 61.57,
    height: 119.86,
    transform: "translate(840.17 -310.37) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.45,295.93H515.09V233.87H635.45Zm-119.86-.5H635V234.37H515.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 522.59,
    y: 242.12,
    width: 50.35,
    height: 45.56,
    transform: "translate(1095.53 529.8) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.09,252.08a5.39,5.39,0,1,0,4.24-4.23A5.4,5.4,0,0,0,529.09,252.08Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "536.76 277.86 572.94 277.86 554.85 253.34 536.76 277.86",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "522.59 277.88 552.46 277.88 537.52 261.92 522.59 277.88",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 522.59,
    y: 277.86,
    width: 50.35,
    height: 9.82,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 581.37,
    y: 242.12,
    width: 42.89,
    height: 3.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 581.37,
    y: 248.58,
    width: 42.89,
    height: 3.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 581.37,
    y: 255.04,
    width: 42.89,
    height: 3.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 581.37,
    y: 261.5,
    width: 42.89,
    height: 3.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 581.37,
    y: 267.96,
    width: 42.89,
    height: 3.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.8,
    y: 228.21,
    width: 113.25,
    height: 144.62,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.55,373.33H114.3V227.71H228.55Zm-113.25-1H227.55V228.71H115.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.8,
    y: 228.21,
    width: 113.25,
    height: 10.83,
    style: {
      fill: "#105099"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.55,239.54H114.3V227.71H228.55Zm-113.25-1H227.55v-9.83H115.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,233.7a2.73,2.73,0,1,1-2.73-2.72A2.72,2.72,0,0,1,125,233.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.08,233.7a2.73,2.73,0,1,1-2.72-2.72A2.72,2.72,0,0,1,136.08,233.7Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.21,233.7a2.73,2.73,0,1,1-2.73-2.72A2.72,2.72,0,0,1,147.21,233.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.8,
    y: 238.54,
    width: 113.25,
    height: 1,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.69,
    y: 339.94,
    width: 55.55,
    height: 5.19,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.69,
    y: 350.02,
    width: 97.47,
    height: 3.13,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.69,
    y: 355.98,
    width: 97.47,
    height: 3.13,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.69,
    y: 361.95,
    width: 97.47,
    height: 3.13,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.77,
    y: 245.5,
    width: 97.3,
    height: 88.04,
    transform: "translate(342.84 579.04) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.34,264.76a10.42,10.42,0,1,0,8.18-8.19A10.43,10.43,0,0,0,135.34,264.76Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.16 314.57 220.07 314.57 185.12 267.19 150.16 314.57",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.77 314.62 180.49 314.62 151.63 283.76 122.77 314.62",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.77,
    y: 314.57,
    width: 97.3,
    height: 18.97,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "600.28 143.9 530.38 143.9 530.38 84.76 565.33 62.57 600.28 84.76 600.28 143.9",
    style: {
      fill: "#105099"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "600.28 143.9 530.38 143.9 530.38 84.76 565.33 62.57 600.28 84.76 600.28 143.9",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "596.34 134.49 534.32 134.49 534.32 54.87 580.37 54.87 596.34 70.04 596.34 134.49",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "580.37 54.87 596.34 70.04 580.37 70.04 580.37 54.87",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.37,
    y: 68.23,
    width: 34.48,
    height: 2.04,
    transform: "translate(1115.23 138.51) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.37,
    y: 73.39,
    width: 34.48,
    height: 2.04,
    transform: "translate(1115.23 148.83) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.37,
    y: 78.55,
    width: 34.48,
    height: 2.04,
    transform: "translate(1115.23 159.15) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.37,
    y: 83.71,
    width: 50.52,
    height: 2.04,
    transform: "translate(1131.27 169.47) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.37,
    y: 88.87,
    width: 50.52,
    height: 2.04,
    transform: "translate(1131.27 179.79) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.37,
    y: 94.03,
    width: 50.52,
    height: 2.04,
    transform: "translate(1131.27 190.11) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.37,
    y: 99.19,
    width: 50.52,
    height: 2.04,
    transform: "translate(1131.27 200.43) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.37,
    y: 104.35,
    width: 50.52,
    height: 2.04,
    transform: "translate(1131.27 210.75) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.37,
    y: 109.51,
    width: 50.52,
    height: 2.04,
    transform: "translate(1131.27 221.07) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.37,
    y: 114.67,
    width: 50.52,
    height: 2.04,
    transform: "translate(1131.27 231.39) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.37,
    y: 119.83,
    width: 50.52,
    height: 2.04,
    transform: "translate(1131.27 241.71) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.37,
    y: 124.99,
    width: 50.52,
    height: 2.04,
    transform: "translate(1131.27 252.03) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.28,99.56v44.33h-69.9V99.56c3,1.7,6,3.49,8.92,5.23s5.92,3.55,8.86,5.35q4.92,3,9.82,6.07l.1-.06-.08.07c2.45,1.52,4.89,3.06,7.34,4.59,2.43-1.53,4.88-3.08,7.32-4.59l-.08-.07.11,0q4.89-3.06,9.81-6.07c2.94-1.79,5.89-3.58,8.85-5.34S597.28,101.26,600.28,99.56Z",
    style: {
      fill: "#105099"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.28,99.56c-2.82,2-5.7,3.89-8.54,5.84s-5.74,3.82-8.63,5.71-6,3.93-9.06,5.87l-.27.19-8,5.13-.4.24-.39-.24q-4-2.56-8-5.14l-.29-.18q-4.54-2.91-9.07-5.88c-2.87-1.88-5.75-3.79-8.62-5.7s-5.72-3.85-8.54-5.84c3,1.7,6,3.49,8.92,5.23s5.92,3.55,8.86,5.35q4.92,3,9.82,6.07h0c2.45,1.52,4.89,3.06,7.34,4.59,2.43-1.53,4.88-3.08,7.32-4.59l0,0q4.89-3.06,9.81-6.07c2.94-1.79,5.89-3.58,8.85-5.34S597.28,101.26,600.28,99.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.08,116.15l-.08.07-1.1.94c-1.76,1.48-3.55,2.89-5.38,4.27-2.22,1.7-4.5,3.33-6.79,4.94s-4.61,3.16-7,4.68-4.75,3-7.21,4.34c2.12-1.86,4.32-3.59,6.55-5.28s4.51-3.33,6.79-4.94,4.62-3.17,7-4.69c1.88-1.2,3.79-2.39,5.74-3.5l1.37-.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.12,135.39c-2.47-1.35-4.86-2.83-7.22-4.34s-4.67-3.09-7-4.68-4.56-3.24-6.79-4.94c-1.81-1.38-3.61-2.78-5.35-4.26l-1.12-1-.08-.07.11,0,1.36.78c2,1.11,3.85,2.3,5.74,3.5,2.37,1.52,4.67,3.09,7,4.69s4.57,3.24,6.8,4.94S598,133.53,600.12,135.39Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-124"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M444.92,458.87c2.1.68,62-.1,64.3-1.58.87-.54,1.26-9.28,1.44-19.86v-.33c0-2.18.07-4.42.07-6.7,0-.31,0-.62,0-.93l-2.91-31.1-40.09.4,4,30.81,0,1.22.25,6.37,0,.66s-22.81,10.56-25.12,12.44S442.82,458.2,444.92,458.87Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.92,458.87c2.1.68,62-.1,64.3-1.58.87-.54,1.26-9.28,1.44-19.86v-.33c0-2.18.07-4.42.07-6.7,0-.31,0-.62,0-.93l-39,.11,0,1.22.25,6.37,0,.66s-22.81,10.56-25.12,12.44S442.82,458.2,444.92,458.87Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.91,458.87c1.09.35,17.37.31,33.28,0l9.42-.22c11.35-.31,20.73-.78,21.6-1.35s1.26-9,1.43-19.42c0-.14,0-.29,0-.44s0-.23,0-.34h-.05l-38.62.08,0,.66s-22.82,10.55-25.13,12.44S442.81,458.2,444.91,458.87Z",
    style: {
      fill: "#105099"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.57,456.54c10.1-.38,50.87-1,60.88-.56.08,0,.08.06,0,.06-10,.6-50.78.84-60.88.67C445.36,456.7,445.35,456.55,445.57,456.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.68,437.34c4-.8,8.84-.25,11.91,2.54.12.11,0,.28-.16.24a55.61,55.61,0,0,0-11.72-2.28A.25.25,0,0,1,467.68,437.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.84,439.1c4-.79,8.83-.24,11.91,2.55.12.11,0,.28-.17.24a55.61,55.61,0,0,0-11.72-2.28A.26.26,0,0,1,464.84,439.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462,440.87c4-.79,8.84-.25,11.91,2.55.12.11,0,.27-.17.23A56.12,56.12,0,0,0,462,441.37.25.25,0,0,1,462,440.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.19,458.86l9.42-.22c11.35-.31,20.73-.78,21.6-1.35s1.26-9,1.43-19.42c0-.14,0-.29,0-.44s0-.23,0-.34h-.05C505.32,440.81,486.68,453.22,478.19,458.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.36,437.3h43.16s-8.69-100.81-8.35-102.57c.43-2.26,16.54-65.33,19.63-77.26,4.64-17.86,8.26-31.75,8.26-31.75H495.48s-4.27,13.52-9.64,31.1c-8.76,28.58-20.45,67.91-21.61,77.48C462.36,349.74,469.36,437.3,469.36,437.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.27,429.94c6.59-.14,4.7-.19,11.29-.25,3.23,0,24.43-.22,27.44.28a.07.07,0,0,1,0,.13c-3,.5-24.21.32-27.44.29-6.59-.07-4.7-.12-11.29-.26A.1.1,0,1,1,471.27,429.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.05,328.57c1.41-6.24,3.53-12.36,5.37-18.48q5.61-18.68,11.29-37.32,2.84-9.31,5.69-18.64c1-3.14,1.93-6.27,2.91-9.4s2.06-6.1,2.92-9.19c.36-1.26.55-.57.1,1-.91,3.22-1.81,6.44-2.75,9.65q-2.79,9.54-5.61,19.07-5.61,19-11.33,37.91-2.85,9.49-5.71,19a76.81,76.81,0,0,0-2.33,9.19,42,42,0,0,0-.38,9.83c.41,6.61,1.17,13.2,1.78,19.79s1.23,13.21,1.84,19.81q1.82,19.71,3.61,39.42c.15,1.67.3,3.33.43,5,0,.56-.8.51-.86,0-1.42-13-2.51-26-3.73-39s-2.43-25.9-3.64-38.85c-.31-3.25-.65-6.51-.65-9.78A39.84,39.84,0,0,1,496.05,328.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.63,225.73c2.24,17.35,5.35,75.62,6,102.9,4.14-16.53,15.58-61.3,18.13-71.16,4.29-16.47,7.7-29.55,8.2-31.49a0,0,0,0,0,0,0,1.22,1.22,0,0,1,0-.17.28.28,0,0,0,0-.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490,458.87c2.1.68,62-.1,64.29-1.58.87-.54,1.27-9.28,1.45-19.86v-.33c0-2.18.07-4.42.07-6.7,0-.31,0-.62,0-.93l-2.91-31.1-40.09.4,4,30.81,0,1.22.25,6.37,0,.66S494.27,448.39,492,450.27,487.88,458.2,490,458.87Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490,458.87c2.1.68,62-.1,64.29-1.58.87-.54,1.27-9.28,1.45-19.86v-.33c0-2.18.07-4.42.07-6.7,0-.31,0-.62,0-.93l-39,.11,0,1.22.25,6.37,0,.66S494.27,448.39,492,450.27,487.88,458.2,490,458.87Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490,458.87c1.08.35,17.37.31,33.28,0l9.42-.22c11.35-.31,20.73-.78,21.6-1.35s1.26-9,1.43-19.42c0-.14,0-.29,0-.44s0-.23,0-.34h-.05l-38.62.08v.66S494.26,448.38,492,450.27,487.88,458.2,490,458.87Z",
    style: {
      fill: "#105099"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.64,456.54c10.1-.38,50.87-1,60.88-.56.08,0,.08.06,0,.06-10,.6-50.78.84-60.88.67C490.42,456.7,490.42,456.55,490.64,456.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.75,437.34c4-.8,8.84-.25,11.91,2.54.12.11,0,.28-.16.24a55.58,55.58,0,0,0-11.73-2.28A.25.25,0,0,1,512.75,437.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.91,439.1c4-.79,8.83-.24,11.91,2.55.12.11,0,.28-.17.24a55.61,55.61,0,0,0-11.72-2.28A.26.26,0,0,1,509.91,439.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.06,440.87c4-.79,8.83-.25,11.91,2.55.12.11,0,.27-.17.23a56.25,56.25,0,0,0-11.72-2.28A.25.25,0,0,1,507.06,440.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.66,225.72s.84,17.51,4.85,31.37c.32,1.15.67,2.27,1.05,3.35,0,0-.56-.44,5.81,3.47,0,0-2.46,69.6-2.56,73.75-.37,15.54,10.93,100.28,10.93,100.28l43.15.17S544.48,342,544.53,336.33c.09-9.15,5.53-48.93,3.85-78.42a83.29,83.29,0,0,0-8.77-32.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.22,430.26c6.59-.11,4.7-.17,11.29-.21,3.23,0,24.43-.11,27.44.4.07,0,.07.13,0,.14-3,.48-24.22.21-27.44.16-6.6-.09-4.7-.13-11.29-.3A.1.1,0,1,1,518.22,430.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537,228.33c5.46,10.5,7.49,22.44,7.93,34.14.48,12.72-1,25.4-2.38,38-1.4,13.27-2.62,26.57-1.61,39.91,1,13.49,3.42,26.86,5.35,40.24s4,26.74,5.63,40.15c.21,1.7.42,3.39.62,5.09a.07.07,0,0,1-.14,0c-2.37-13.21-4.31-26.5-6.33-39.77s-4.28-26.44-5.65-39.74-.79-26.49.55-39.75c1.28-12.77,3-25.53,3-38.39,0-11.95-1.16-24.18-5.4-35.45-.56-1.5-1.17-3-1.8-4.47C536.73,228.12,536.93,228.11,537,228.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.76,259.4a80.92,80.92,0,0,1,12.34,6.46c.15.1,0,.34-.13.26-4.16-2-8.41-4-12.46-6.22A.28.28,0,0,1,500.76,259.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.52,244.55c.28,1.54.66,3.06,1,4.58s.54,2.89.91,4.3a7.36,7.36,0,0,0,2,3.61c.56.52,1.18,1,1.78,1.46.32.26.67.51,1,.77,0-.2-.07-.41-.11-.62l-.3-1.74c-.22-1.3-.42-2.59-.62-3.89-.39-2.54-.75-5.11-1.28-7.63a.08.08,0,0,1,.16,0c.63,2.49,1.33,5,1.89,7.48.27,1.24,1.23,7.34,1.28,7.77s.08.89.09,1.34a4.84,4.84,0,0,1,0,1.37c0,.11-.16.09-.2,0h0a5.5,5.5,0,0,1-.39-1.33c-.11-.43-.21-.87-.29-1.32,0-.16-.05-.32-.07-.48-.6-.37-1.16-.85-1.72-1.26s-1.22-.86-1.79-1.34a6.85,6.85,0,0,1-2.19-3.42,24.08,24.08,0,0,1-.72-4.39c-.2-1.73-.34-3.47-.58-5.2C500.35,244.49,500.5,244.45,500.52,244.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.78,178.44c.13,7.9-4.9,45.05-12.43,53.66-10,11.39-27.91,26.72-31.43,26.14-3.36-.55-16.84-19.56-14.33-22.21s24.93-17.24,27.79-20.12C475.3,214,486.53,192,493,180.5,498.87,170.09,503.61,167.57,503.78,178.44Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.56,201.23,478.94,200s12.78-21.39,18.32-26.62c6.23-5.89,7.88-1.41,7.71,6.73S501.56,201.23,501.56,201.23Z",
    style: {
      fill: "#105099"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.35,196.12c.79-.08,7.84.21,9.37.3s7.81.43,9.38.66c.07,0,.07.11,0,.11-1.58.07-7.91-.24-9.47-.31s-8.54-.5-9.3-.66C482.27,196.21,482.29,196.12,482.35,196.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505,180.07c-.16,8.14-3.41,21.16-3.41,21.16l-13.25-.74L500.55,171C504.09,169.45,505.1,173.61,505,180.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.69,246.88c1,1,61.75-2.23,62.05-2.63.79-1.07-20.42-64.91-34.67-75.14-3.06-2.2-11.81-.09-13.92,2-1.33,1.33-4.21,9.74-6.1,16.69C490.27,201.75,485.83,246,486.69,246.88Z",
    style: {
      fill: "#105099"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.69,182.64a6.73,6.73,0,0,1-.53-1.9.49.49,0,0,1,0-.12c.19.33.38.67.59,1A4.31,4.31,0,0,1,523.69,182.64Zm-19,43a7.14,7.14,0,0,0,0,2,6.82,6.82,0,0,0,.53,1.9,6.84,6.84,0,0,0,0-2A6.76,6.76,0,0,0,504.69,225.65Zm17-10.72a7.21,7.21,0,0,0,0,2,6.76,6.76,0,0,0,.53,1.89,7.53,7.53,0,0,0-.55-3.86Zm1.13,26.18a7.82,7.82,0,0,0,.55,3.86,6.84,6.84,0,0,0,0-2A6.76,6.76,0,0,0,522.8,241.11Zm18.5-11.35a6.83,6.83,0,0,0,0,2,6.76,6.76,0,0,0,.53,1.89,6.76,6.76,0,0,0,0-2A6.89,6.89,0,0,0,541.3,229.76Zm-40.61-35.71a7.53,7.53,0,0,0,.55,3.86,6.84,6.84,0,0,0,0-2A6.74,6.74,0,0,0,500.69,194.05Zm0-20.22a7.53,7.53,0,0,0,.55,3.86,6.84,6.84,0,0,0,0-2A6.74,6.74,0,0,0,500.69,173.83Zm31,26.8a7.21,7.21,0,0,0,0,2,6.83,6.83,0,0,0,.52,1.89,7.49,7.49,0,0,0-.55-3.86ZM514,189.06a7.13,7.13,0,0,0,2,0,6.74,6.74,0,0,0,1.89-.52,7.47,7.47,0,0,0-3.85.55Zm-7.92-19.53a6.76,6.76,0,0,0,2,0,6.89,6.89,0,0,0,1.9-.52,6.83,6.83,0,0,0-2,0A6.76,6.76,0,0,0,506.08,169.53Zm-11.89,17.81c-.05.16-.09.33-.14.49,0,0,0,0,0,0l.2,0a6.5,6.5,0,0,0,1.89-.52A6.63,6.63,0,0,0,494.19,187.34Zm3.89,20.48a6.76,6.76,0,0,0,2,0,6.89,6.89,0,0,0,1.9-.52,6.83,6.83,0,0,0-2,0A6.76,6.76,0,0,0,498.08,207.82Zm18.73-1.57a7.82,7.82,0,0,0,3.86-.55,6.84,6.84,0,0,0-2,0A6.76,6.76,0,0,0,516.81,206.25Zm-4.74,30.39a7.47,7.47,0,0,0,3.85-.55,7.47,7.47,0,0,0-3.85.55ZM531,223.09a6.84,6.84,0,0,0,2,0,6.76,6.76,0,0,0,1.89-.53,7.82,7.82,0,0,0-3.86.55Zm-39.6,21.37a6.83,6.83,0,0,0,2,0,6.76,6.76,0,0,0,1.89-.53,6.76,6.76,0,0,0-2,0A7.26,7.26,0,0,0,491.35,244.46Zm-1.42-15.94a7.21,7.21,0,0,0,2,0,6.74,6.74,0,0,0,1.89-.52,7.53,7.53,0,0,0-3.86.55Zm24.53-53.07a7.73,7.73,0,0,0-2.34,3.12,7.73,7.73,0,0,0,2.34-3.12ZM492,197.79c-.06.33-.12.66-.17,1a6.82,6.82,0,0,0,.49-.58,7,7,0,0,0,1-1.71A6.57,6.57,0,0,0,492,197.79Zm33.75-3.57a7.61,7.61,0,0,0-2.34,3.11,7,7,0,0,0,1.38-1.4A7.17,7.17,0,0,0,525.75,194.22Zm-16.23,18.17a7.61,7.61,0,0,0-2.34,3.11,7,7,0,0,0,1.38-1.4A7.17,7.17,0,0,0,509.52,212.39Zm-9.94,22.08a7.73,7.73,0,0,0-2.34,3.12,7.73,7.73,0,0,0,2.34-3.12Zm26.51-5.89a7.61,7.61,0,0,0-2.34,3.11,7.61,7.61,0,0,0,2.34-3.11Zm19,11a7.73,7.73,0,0,0-2.34,3.12,7.5,7.5,0,0,0,2.34-3.12ZM490,211.26l-.06.48a5.79,5.79,0,0,0,1,.47A5.86,5.86,0,0,0,490,211.26Zm43.11,1.66a7.31,7.31,0,0,0-1.41-1.37,6.83,6.83,0,0,0-1.71-1,7.5,7.5,0,0,0,3.12,2.34Zm1.55,26.39a7,7,0,0,0-1.4-1.37,6.7,6.7,0,0,0-1.71-1,6.72,6.72,0,0,0,1.4,1.37A6.87,6.87,0,0,0,534.64,239.31Zm-27.78-52.25a7,7,0,0,0-1.41-1.37,6.83,6.83,0,0,0-1.71-1,7.08,7.08,0,0,0,1.41,1.38A6.8,6.8,0,0,0,506.86,187.06Zm9.06,38.1a7.39,7.39,0,0,0-3.11-2.34,7,7,0,0,0,1.4,1.37A7.2,7.2,0,0,0,515.92,225.16Zm-28.7,12.23-.12-.08c0,.19,0,.39-.05.58a6.86,6.86,0,0,0,1.57.87A7.26,7.26,0,0,0,487.22,237.39Zm25.14-37.09a7,7,0,0,0-1.4-1.38,7.17,7.17,0,0,0-1.71-1,7.61,7.61,0,0,0,3.11,2.34Zm-13.55,20a7.73,7.73,0,0,0-3.12-2.34,7.33,7.33,0,0,0,3.12,2.34Zm9.31,24.43a7,7,0,0,0-1.4-1.37,7.07,7.07,0,0,0-1.72-1,6.77,6.77,0,0,0,1.41,1.37A6.7,6.7,0,0,0,508.12,244.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.95,
    y: 205.09,
    width: 11.45,
    height: 66.83,
    transform: "translate(-36.37 385.29) rotate(-43.26)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "520.16 281.65 507.55 293.52 507.55 293.52 475.57 259.53 475.57 259.53 488.18 247.66 488.18 247.66 520.16 281.65",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.11,230.42a52.18,52.18,0,1,1,46-57.68A52.24,52.24,0,0,1,417.11,230.42Zm-11-97.77a46.2,46.2,0,1,0,51.07,40.76A46.26,46.26,0,0,0,406.12,132.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.24,232.25a53.71,53.71,0,1,1,6-.34A56.15,56.15,0,0,1,411.24,232.25Zm.08-104.37a52.41,52.41,0,0,0-5.7.32,50.65,50.65,0,1,0,5.7-.32Zm-.07,98.38a47.7,47.7,0,0,1-5.29-95.1h0A47.7,47.7,0,0,1,416.61,226,46.22,46.22,0,0,1,411.25,226.26Zm-5-92.11a44.67,44.67,0,1,0,49.41,39.42,44.74,44.74,0,0,0-49.41-39.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M443.61,148.15a44.39,44.39,0,1,1-62.75-1.92A44.39,44.39,0,0,1,443.61,148.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.85,158.42A44.43,44.43,0,0,1,431.78,218Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.14,134.21,387,215.76A45.16,45.16,0,0,1,379,209a43.88,43.88,0,0,1-7-9.84L391.22,139A44.43,44.43,0,0,1,413.14,134.21Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.42,145.08l-24.87,77.67a44.57,44.57,0,0,1-8.72,0L433.32,140A42.94,42.94,0,0,1,440.42,145.08Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.18,134.89l-26.84,83.83c-.49-.23-1-.46-1.44-.71l26.69-83.38C418.12,134.7,418.65,134.78,419.18,134.89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.27,147.8,367.36,185c-.2-1.32-.33-2.64-.4-4l9.69-30.26C377.47,149.76,378.34,148.76,379.27,147.8Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M524.58,177.18c5.17,6,26.74,35.21,26.68,48.78,0,8.31-21.06,32.12-26.53,37.7-2.39,2.43-19.5-12.46-19.34-16.1s20.76-24.72,21.7-27.28c0,0-7.36-23.68-11.26-36.29C512.15,172.07,514.94,166,524.58,177.18Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.46,264.18c-3.14,2.88-9.65,4.08-8.28,6.94,1.21,2.55,5.64,1.28,5.64,1.28s-4.53,3.05-2.44,5.42,6.66,0,6.66,0-3.89,2.36-1.63,4.58,6.5.89,6.5.89-.65,1.44,1.65,2.29c3.28,1.21,9.72-2.74,12.6-5.61s11.28-15.47,12.53-17.43l-18.22-18.61s-7.46,2.74-11.08,4.58-13.83,11.25-11.67,13.94,9.26-4.06,11.36-5.34,2.76-1,2.26.31C498,258.26,493.84,262.9,492.46,264.18Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490,272.24c6-2.21,8.31-4.23,12.18-9.24.07-.1.24,0,.17.1-3.35,5.26-5.82,8.19-12.26,9.43C489.77,272.6,489.71,272.34,490,272.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.76,277.83c6.08-2.84,8.55-5,13-10,.06-.07.19,0,.13.1-3.95,5.23-6.48,8.1-12.93,10.14C493.66,278.21,493.48,278,493.76,277.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499,283.19c5.69-3.18,8.5-5.43,12.2-10.79a.12.12,0,0,1,.2.12c-3.23,5.84-6.72,8.67-12.28,10.84C498.69,283.5,498.59,283.39,499,283.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.32,201.26l22.4-3.4S527,177.77,521,173.09c-6.75-5.28-8-.67-7,7.43S519.32,201.26,519.32,201.26Z",
    style: {
      fill: "#105099"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538,194.36c-.79,0-7.79.95-9.3,1.19s-7.73,1.16-9.27,1.53a.06.06,0,0,0,0,.12c1.58-.08,7.84-1,9.39-1.21s8.46-1.3,9.2-1.52C538.05,194.45,538,194.36,538,194.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.09,201c-.68.05-1.74.18-1.74.18-.9-2.48-4.3-15.38-5.18-18.48,0-.05-.08,0-.07,0q.57,2.67,1.18,5.34l-.27-.64c-.32-.76-.66-1.5-1-2.27a.05.05,0,0,0-.1,0,19.71,19.71,0,0,0,.8,2.35c.23.53.49,1.05.77,1.56.24,1,.47,2,.73,3.05.82,3.11,1.55,6.36,2.61,9.4a12.11,12.11,0,0,0,2.26-.39A.08.08,0,0,0,521.09,201Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.2,238.51a4.1,4.1,0,0,0,4.16,2.54s-2.12,3.31-.32,6c.93,1.41,4,1.16,4,1.16s-1.58,2.74.17,5.07c1.4,1.85,4.26,1.33,4.26,1.33s-.3,3.33,1.73,4.76c4.11,2.91,21.22-7.33,20.09-15.21-.53-3.68-4.57-.95-4.57-.95s4.87-5.33,2.85-8.91-7.06.28-7.06.28,4.67-5.2,2.2-8.7-6.95,1.08-6.95,1.08,2.26-4.86-.25-7.1c-4.13-3.72-8.67,7.37-13,8.73l-5.72-6.1S441.75,235.26,443.2,238.51Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.91,254.63a.05.05,0,0,0,0,.1,34.62,34.62,0,0,0,17-11.6c.13-.18-.1-.48-.28-.31A70.85,70.85,0,0,1,455.91,254.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451,248.34c-.07,0,0,.15.07.12,6.63-2.09,13.79-7,17.75-13.8.14-.24,0-.58-.15-.33C465.65,238.67,456.75,245.51,451,248.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.87,226.41c-4.05,6.39-9.74,10.84-16.24,14.56-.08.05,0,.17.08.14,3.67-1,7.57-3.76,10.41-6.2a19.91,19.91,0,0,0,6-8.36C464.14,226.42,464,226.27,463.87,226.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.3,169.6c-2.64,2-5.06,11.62,1,13s11.63-8.16,12.46-11.24S507,165.36,501.3,169.6Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.05,180.66c3.42.44,8.61-5.26,10.43-9.62.13-.3-.62-3.24-1.36-6.86-.44-2.19-.88-4.64-1.11-6.91l-13.87,4.95a36.16,36.16,0,0,1,2.29,8.56,4.92,4.92,0,0,1,0,.94c0,.05,0,.1,0,.16C499.32,173.68,499.75,180.23,503.05,180.66Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.35,157.5c-.15,2.88-1.24,13.26-9.46,14.31a9.36,9.36,0,0,1-1.46.07.85.85,0,0,1,0-.16,4.92,4.92,0,0,0,0-.94,36.32,36.32,0,0,0-2.29-8.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.89,141.7c1.81,5-.12,19.76-3.55,23.21-5,5-13.51,5.89-17.85-.18-4.21-5.89-1.36-25.09,2.51-28.27C497.7,131.79,508.22,134.34,510.89,141.7Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.9,151.08s.07.06.07.1c-.16,1-.17,2.15.69,2.59,0,0,0,.07,0,.06C497.56,153.54,497.59,152,497.9,151.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.92,150.15c1.62.08,1.34,3.31-.16,3.24S497.56,150.09,498.92,150.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.15,150.62s-.09,0-.09.08c-.05,1-.28,2.14-1.22,2.4,0,0,0,.05,0,.05C492,153.09,492.26,151.58,492.15,150.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.34,149.5c-1.59-.26-2,2.95-.52,3.19S492.68,149.72,491.34,149.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.32,148.79a13.18,13.18,0,0,1-1.21-.55,2.11,2.11,0,0,1-1.13-.8.66.66,0,0,1,.18-.81,1.68,1.68,0,0,1,1.72,0,2.54,2.54,0,0,1,1.34,1.2A.73.73,0,0,1,500.32,148.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.23,147.77c.46,0,.87-.15,1.32-.23a2.13,2.13,0,0,0,1.29-.48.68.68,0,0,0,0-.83,1.7,1.7,0,0,0-1.66-.47,2.59,2.59,0,0,0-1.6.82A.74.74,0,0,0,490.23,147.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.11,160.46c-.26.21-.53.52-.9.52a2.83,2.83,0,0,1-1-.35,0,0,0,0,0-.05.05,1.36,1.36,0,0,0,1.23.65,1.07,1.07,0,0,0,.86-.82S498.14,160.43,498.11,160.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.31,157.38a3.43,3.43,0,0,1-2.4,1.32,4.63,4.63,0,0,1-1.23,0l-.23-.05-.22,0a.26.26,0,0,1-.18-.24h0l0-.1h0v-.09c.05-.77.22-1.93.22-1.93-.29.12-1.78.64-1.72.24a51.19,51.19,0,0,1,2.2-10.19.09.09,0,0,1,.18,0c-.34,3.2-1.24,6.32-1.63,9.53a6.26,6.26,0,0,1,1.65-.35c.1,0-.38,2.25-.37,2.59a0,0,0,0,0,0,0,4.73,4.73,0,0,0,3.62-.79C497.31,157.23,497.38,157.3,497.31,157.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.26,158.48a4,4,0,0,0,1.61,1.25,1.87,1.87,0,0,0,1.1.06c.8-.21.81-.94.67-1.56a4.3,4.3,0,0,0-.36-.95A5.24,5.24,0,0,1,494.26,158.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.87,159.73a1.87,1.87,0,0,0,1.1.06c.8-.21.81-.94.67-1.56A1.89,1.89,0,0,0,495.87,159.73Z",
    style: {
      fill: "#f392b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.15,142.13s0,0,0,0l0,.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.41,155.37c-2.75-.79-4.11-10-4.11-10s0,3.91-.72,3.81-3.72-5.41-4-9.21a30.05,30.05,0,0,1-7,3.37c-3.47,1-7.32.78-7.32.19,0-1.76,1.62-6.35,4-8a12.4,12.4,0,0,1,12.36-1.48c5.67,2.19,7.15,5.85,8,8.68S512.42,155.66,511.41,155.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.76,157.07a4.85,4.85,0,0,1-3.42-5.94h0a4.85,4.85,0,1,1,4.61,6.11A5,5,0,0,1,498.76,157.07ZM496,151.3a4.2,4.2,0,1,0,5.15-3,4.64,4.64,0,0,0-1-.14A4.22,4.22,0,0,0,496,151.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.62,155.71c-2-.26-3.3-2.62-2.95-5.27a5.77,5.77,0,0,1,1.45-3.23,3,3,0,0,1,5.13.67,5.73,5.73,0,0,1,.57,3.49c-.32,2.51-2,4.39-3.89,4.36Zm-1-8.05a5.11,5.11,0,0,0-1.28,2.86c-.3,2.3.77,4.34,2.39,4.55s3.18-1.48,3.48-3.78a5.15,5.15,0,0,0-.5-3.1,2.6,2.6,0,0,0-1.89-1.45h-.24A2.67,2.67,0,0,0,487.59,147.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.43,151.71l.47-.44c-.64-.71-2.22-1.75-3.56-.65l.41.5C494,150.13,495.37,151.64,495.43,151.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.82,155.55l.61-.23c-.11-.28-1-2.78-2.45-3.2a60.18,60.18,0,0,0-7.54-.52l0,.64a55.75,55.75,0,0,1,7.38.5C512.72,153,513.57,154.86,513.82,155.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.67,153.56s3.16-4.84,5.35-3.73-.09,8.06-2.58,9.08a2.57,2.57,0,0,1-3.48-1.28Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.32,151.8a0,0,0,0,1,0,.07c-1.74.77-2.62,2.44-3.22,4.16a1.42,1.42,0,0,1,2.11-.45s0,.11-.05.1a1.57,1.57,0,0,0-1.72.6,8.27,8.27,0,0,0-.79,1.43c-.07.16-.36.09-.31-.1v0C508.25,155.32,509.9,152.11,512.32,151.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.84,133.78a20.14,20.14,0,0,1,5.6-2.08c2.19-.42,9.2-.34,11,1s2.64,7.83,2.74,8.79.06,6.8-1.95,8.34-2.86-8.32-6.4-11.38S495.84,133.78,495.84,133.78Z",
    style: {
      fill: "#105099"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.84,133.78s7.42,1.56,11,4.62,4.39,12.92,6.4,11.38a4.63,4.63,0,0,0,1.56-3.2c-.63-2.85-2.09-7.25-4.7-10.2-2.44-2.75-6.42-4-10.59-4.17A23.69,23.69,0,0,0,495.84,133.78Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513,155.68c-.36-2.62-3.5-9.49-6.57-13.34s-11.48-5.68-12.63-5.53c-2.79.34-3.68,1.25-4.14,1s2.28-2.52,3-3,2.81-1.77,4-1.83,8.77.21,11.71,3.23,7.39,11.74,6.83,14.08c-.13.57-.84,1-1,1.77-.24,1-.37,2.24-.64,3S513,155.9,513,155.68Z",
    style: {
      fill: "#105099"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.68,140.57a14.21,14.21,0,0,0,1.73-1.46,9.77,9.77,0,0,0,1.45-1.76s.1,0,.07,0a7.09,7.09,0,0,1-1.29,2,6.12,6.12,0,0,1-1.9,1.36C505.67,140.73,505.61,140.61,505.68,140.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.86,153.05a5.69,5.69,0,0,1,.26-.56,4,4,0,0,0,.2-.67,6.3,6.3,0,0,1,.21-1.3,4.74,4.74,0,0,1,.56-.91,1.77,1.77,0,0,0,.45-1.11,0,0,0,0,1,.09,0,4.55,4.55,0,0,1-.75,2.09,8.13,8.13,0,0,0-.27,1.39,2.1,2.1,0,0,1-.62,1.15C512.93,153.16,512.84,153.12,512.86,153.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.77,150.26a10.72,10.72,0,0,0,.68-.94,9.63,9.63,0,0,0,.5-1c.14-.35.26-.7.4-1.05s.37-.8.51-1.22c0-.05.1,0,.08,0-.14.43-.22.89-.35,1.33a9.27,9.27,0,0,1-.43,1.1,6,6,0,0,1-.56,1,2.81,2.81,0,0,1-.8.81S511.75,150.29,511.77,150.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.64,147.75A7.35,7.35,0,0,0,512,146c.34-.62.65-1.26.95-1.9,0,0,.1,0,.08,0a9,9,0,0,1-.77,2.06,4.9,4.9,0,0,1-.62.87,4.82,4.82,0,0,1-.9.72S510.6,147.79,510.64,147.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.44,145.36a2.59,2.59,0,0,0,.65-.75c.21-.31.41-.63.6-1s.38-.61.56-.92a2.61,2.61,0,0,0,.41-1c0-.05.08-.05.09,0a2.73,2.73,0,0,1-.24,1.05,7.1,7.1,0,0,1-.53,1.07,10.33,10.33,0,0,1-.67,1,1.75,1.75,0,0,1-.81.64C509.43,145.48,509.38,145.4,509.44,145.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.48,142.28c.23-.25.46-.51.67-.78s.4-.55.58-.84.41-.59.59-.9a0,0,0,0,1,.08,0,7.22,7.22,0,0,1-.43,1,7.13,7.13,0,0,1-.58.89,7.28,7.28,0,0,1-.67.8,2.77,2.77,0,0,1-.82.66s-.1,0-.07-.09A5.89,5.89,0,0,1,508.48,142.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.56,139.2c.24-.34.47-.67.74-1a10.78,10.78,0,0,1,.88-.91,10.94,10.94,0,0,1,1.95-1.51s.1,0,.06.06c-1.17,1.15-2.4,2.25-3.56,3.41A0,0,0,0,1,503.56,139.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.82,137.06a5.19,5.19,0,0,1,.84-.91,11.82,11.82,0,0,1,2.17-1.4c.05,0,.1,0,.05.07-.65.5-1.31,1-1.94,1.52a11.52,11.52,0,0,0-.89.83c-.27.3-.48.65-.74,1,0,0-.07,0-.06,0A2.94,2.94,0,0,1,501.82,137.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.56,136.17a6.09,6.09,0,0,1,.77-.9,6.66,6.66,0,0,1,1.85-1.26c.05,0,.08.05,0,.08a14.76,14.76,0,0,0-1.73,1.43c-.26.27-.52.54-.77.82s-.47.61-.75.85c0,0-.05,0,0,0A6.38,6.38,0,0,1,499.56,136.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.89,135l.81-.7a3.46,3.46,0,0,1,.89-.57s.07,0,0,.07c-.51.47-1,.94-1.52,1.42a8.52,8.52,0,0,0-1.13,1.53,0,0,0,0,1-.05,0A3.39,3.39,0,0,1,497.89,135Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.89,134.66a5.32,5.32,0,0,1,1.69-1.2s.08,0,0,.07a6.55,6.55,0,0,0-1.52,1.31,9.36,9.36,0,0,0-1.16,1.64s-.07,0-.06,0A4.66,4.66,0,0,1,495.89,134.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.38,136c.06-.14.13-.28.2-.41a5,5,0,0,1,.54-.76,8.83,8.83,0,0,1,1.42-1.24s.09,0,0,.07a7.55,7.55,0,0,0-1.32,1.27,6.53,6.53,0,0,0-.52.74c-.08.12-.14.25-.21.38a2.35,2.35,0,0,1-.19.39s-.08,0-.08,0A1.24,1.24,0,0,1,493.38,136Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.81,136.26a7.07,7.07,0,0,1,.44-.63c.16-.19.33-.38.51-.56s.39-.35.57-.54.1,0,.06.06a4.78,4.78,0,0,0-.52.59l-.46.59c-.15.19-.31.38-.46.58a6.7,6.7,0,0,1-.45.6,0,0,0,0,1-.06,0A3,3,0,0,1,491.81,136.26Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-124"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M678.59,285.27c-11.21,15.18-22.89,32.78-25.73,51.81,0,.29.43.38.49.1a113,113,0,0,1,5-15.24c7.36-2,14.59-3.69,18.46-11,3.94-7.51,3.44-17.31,2.69-25.5C679.41,285,678.82,285,678.59,285.27Z",
    style: {
      fill: "#105099"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.42,321.8c5-11.29,11.49-22.63,19.7-31.92a.06.06,0,0,1,.09.09c-5.37,6.61-9.46,13.82-13.45,21.15,3.71-3.77,7.78-7.14,11.29-11.14.07-.07.18,0,.11.12-3.49,4.18-7.3,8.73-11.84,11.83-1.22,2.25-2.45,4.51-3.7,6.76.31-.17.62-.32.94-.48.05,0,.1.06.05.09-.35.17-.69.36-1.05.51l-1.78,3.2C658.64,322.25,658.31,322,658.42,321.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.16,317.86a66,66,0,0,0,8.6-5.74c.07-.06.18,0,.11.1a45.79,45.79,0,0,1-8.58,5.85C662.15,318.14,662,317.94,662.16,317.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.56,334.25c0,.23.42.23.41,0,.06-6.26,0-12.56.1-18.85,1.61-3.24,5-5,7.45-7.63a33.62,33.62,0,0,0,4.47-6.22,44.76,44.76,0,0,0,5.18-17.29c.66-6.7-1.88-28.81-4.71-28.05-1.46.4-6.2,11.36-7.46,15a104.16,104.16,0,0,0-4.46,18.36C650.25,304.27,650.44,319.41,651.56,334.25Z",
    style: {
      fill: "#105099"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.52,307.22l0,0c.34-7.93,2.13-15.94,3.8-23.63,1.8-8.28,3.9-16.08,8.17-23.47.08-.13.28,0,.21.13a86.61,86.61,0,0,0-6.56,18c.28-.44.63-.87.93-1.29.11-.17.39,0,.27.16A11.38,11.38,0,0,1,657,279l-.06,0c-1.46,5.92-2.52,12-3.42,18l.2-.24c0-.05.13,0,.09.07s-.23.4-.36.6c-.45,3.07-.87,6.13-1.29,9.16,5.46-4.66,10.12-10.16,12.75-16.94,0,0,.06,0,0,0-2.58,7-6.64,13.28-12.89,17.55-.11.82-.23,1.63-.35,2.45,0,.17-.29.12-.29,0,0-.73,0-1.45.07-2.17A.17.17,0,0,1,651.52,307.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.09,295.74c4.17-6.23,8.07-12.28,11.12-19.16a.08.08,0,0,1,.14.06c-2.57,6.83-6.18,13.76-11.05,19.26C654.2,296,654,295.86,654.09,295.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.63,275c1.73-3.06,3.56-6,5.18-9.15.05-.09.17,0,.13.07a47,47,0,0,1-5,9.24C659.79,275.35,659.53,275.22,659.63,275Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659,276.37a0,0,0,0,1,0,.05A0,0,0,0,1,659,276.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.32,316.13a63.23,63.23,0,0,1-1.46,12.35c.06.44.13.89.19,1.35a59.06,59.06,0,0,0,2.21-13.76.44.44,0,0,0,0-.43h0A91.81,91.81,0,0,0,646.9,297c-1.94-11.52-6.18-22.57-14.22-31.2a.56.56,0,0,0-.88.18c-3.24,8.24-2.11,18.07.65,26.29a47.83,47.83,0,0,0,6.37,12.49C641.57,308.62,645.08,311.9,647.32,316.13Z",
    style: {
      fill: "#105099"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.63,269.64c7.62,12.36,12.91,27,13.56,41.59,0,.26-.42.33-.46.07-.18-1.31-.38-2.61-.59-3.91h0c-3.15-3-6.39-6.2-8.64-10a.07.07,0,0,1,.11-.08,105,105,0,0,0,8.39,9.13c-.55-3.23-1.19-6.4-2-9.53l-.6-.71c-.13-.16.09-.38.22-.23l.19.21a111,111,0,0,0-4-12.64c-1.94-2.31-4.11-4.31-5.52-7.09a.06.06,0,0,1,.1-.06c1.14,1.59,2.24,3.19,3.52,4.67.52.59,1.08,1.14,1.61,1.72a97.07,97.07,0,0,0-6.23-13A.17.17,0,0,1,633.63,269.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.17,284.88c2.46,3.31,5.27,6.47,7.55,9.89.07.1-.07.2-.16.13A50.77,50.77,0,0,1,635,285C634.94,284.87,635.1,284.79,635.17,284.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.07,295.54l.1.11c.08.07,0,.18-.11.11l-.1-.11C642.88,295.58,643,295.47,643.07,295.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.71,293.39a37.81,37.81,0,0,0,8,18.84,20,20,0,0,0,6.51,5.09c2.83,1.39,5.78,3,8.7,4.14A57.46,57.46,0,0,1,648,332.4c.1-.32.19-.65.29-1-1.88-16.09-12.29-29.84-25.61-38.67A.64.64,0,0,0,621.71,293.39Z",
    style: {
      fill: "#105099"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.31,298.14c-.09-.08,0-.25.14-.17a54.64,54.64,0,0,1,17,20.91c.09.22-.21.42-.33.2-.62-1.09-1.25-2.14-1.9-3.18h0c-3-.57-5.91-2.71-8.17-4.74a.06.06,0,0,1,.09-.09,18.4,18.4,0,0,0,3.85,2.7,41.29,41.29,0,0,0,3.86,1.53c-1.13-1.79-2.3-3.5-3.53-5.17a35.37,35.37,0,0,1-9.13-5.13c-.09-.06,0-.21.08-.15a92.55,92.55,0,0,0,8.49,4.54,75.77,75.77,0,0,0-6-7c-1-.54-2.08-1.09-3.08-1.68-.08,0,0-.18.06-.15a10.82,10.82,0,0,1,2.37,1.16C628.88,300.51,627.64,299.31,626.31,298.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.59,303.7a3.77,3.77,0,0,1,.52.37s0,.1-.07.08a5.54,5.54,0,0,1-.53-.3C626.42,303.79,626.5,303.64,626.59,303.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "669.09 367.24 632.6 367.24 635.54 334.01 636.19 326.68 665.5 326.68 666.14 334.01 669.09 367.24",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "666.14 334.01 635.54 334.01 636.19 326.68 665.5 326.68 666.14 334.01",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 634.44,
    y: 321.55,
    width: 32.8,
    height: 7.25,
    style: {
      fill: "#455a64"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpired);
export default __webpack_public_path__ + "static/media/expired.2a2283417e7b5f5d98c072fa9ba94015.svg";
export { ForwardRef as ReactComponent };